<template>
  <router-link v-if="project" :to="{ name: 'project', params: { slug: slug } }">
    <span v-if="side == 'left'" class="image" :class="getClasses">
      <img :src="project.field_main_image[0].uri[0].url | buildUrl" />
    </span>
    <span @mouseenter="onMouseEnter()" @mouseleave="onMouseLeave()">{{
      project.title[0].value
    }}</span>
    <span v-if="side == 'right'" class="image" :class="getClasses">
      <img :src="project.field_main_image[0].uri[0].url | buildUrl" />
    </span>
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      project: null,
    };
  },
  props: {
    slug: String,
    side: String,
    mode: String,
  },
  computed: {
    getClasses() {
      return {
        left: this.side == "left",
        right: this.side == "right",
        portrait: this.mode == "portrait",
        landscape: this.mode == "landscape",
      };
    },
  },
  methods: {
    onMouseEnter() {
      this.$store.commit("SET_NAV_LINK_IS_HOVERED", true);
    },
    onMouseLeave() {
      this.$store.commit("SET_NAV_LINK_IS_HOVERED", false);
    },
  },
  async mounted() {
    this.project = this.$store.state.projects.find(
      (p) => p.field_slug[0].value == this.slug
    );
  },
};
</script>